import { render, staticRenderFns } from "./TechPack.vue?vue&type=template&id=9c42bba8"
import script from "./TechPack.vue?vue&type=script&lang=js"
export * from "./TechPack.vue?vue&type=script&lang=js"
import style0 from "./TechPack.vue?vue&type=style&index=0&id=9c42bba8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports